import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../features/auth/AuthContext";
import { TimeRange } from "../../utils/timerange";
import { fetchDistinctUsers } from "../queries/artifacts";

interface UseDistinctUsersParams {
  timeRange: TimeRange;
  permittedEmails: string[] | null;
}

export const useDistinctUsers = (params: UseDistinctUsersParams) => {
  const { tenantId } = useAuth();
  const { timeRange, permittedEmails } = params;

  return useQuery({
    queryKey: ["distinctUsers", tenantId, timeRange, permittedEmails],
    queryFn: () => fetchDistinctUsers({ timeRange, permittedEmails }),
    staleTime: 1 * 60 * 1000, // 5 minutes - users don't change often
    gcTime: 2 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
  });
};
